import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const getGanttData = async () => {
    // @ts-ignore
    const url = routable.getRoute('getEstimateGanttData');
    try {
        return $api.get(url);
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
